var _path, _circle, _circle2, _circle3, _path2, _path3, _path4;

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import * as React from "react";

const SvgBz = props => /*#__PURE__*/React.createElement("svg", _extends({
  xmlns: "http://www.w3.org/2000/svg",
  viewBox: "0 0 512 512"
}, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
  fill: "#0052b4",
  d: "M0 85.331h512v341.337H0z"
})), _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
  cx: 256,
  cy: 255.994,
  r: 81.619,
  fill: "#f0f0f0"
})), _circle2 || (_circle2 = /*#__PURE__*/React.createElement("circle", {
  cx: 256,
  cy: 255.994,
  r: 66.783,
  fill: "#6da544"
})), _circle3 || (_circle3 = /*#__PURE__*/React.createElement("circle", {
  cx: 256,
  cy: 255.994,
  r: 44.522,
  fill: "#f0f0f0"
})), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
  fill: "#0052b4",
  d: "M256 244.864l-24.116 11.13v18.55L256 289.386l24.116-14.842v-18.55z"
})), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
  fill: "#ffda44",
  d: "M231.88 233.734h48.228v22.261H231.88z"
})), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
  d: "M0 85.331h512v29.68H0zm0 311.653h512v29.682H0z",
  fill: "#a2001d"
})));

export default SvgBz;